<template>
  <nav
    class="header-navbar navbar navbar-with-menu navbar-fixed-top navbar-semi-dark navbar-shadow"
  >
    <div class="navbar-wrapper">
      <div class="navbar-header">
        <ul class="nav navbar-nav">
          <li class="nav-item mobile-menu hidden-md-up float-xs-left">
            <a class="nav-link nav-menu-main menu-toggle hidden-xs">
              <i class="icon-menu5 font-large-1"></i>
            </a>
          </li>
          <li class="nav-item">
            <router-link to="/" class="navbar-brand nav-link">
              <img
                alt="CITY GAS SERVICE"
                src="/static/app-assets/images/logo/gas-logo-light-small.png"
                data-expand="/static/app-assets/images/logo/gas-logo-light.png"
                data-collapse="/static/app-assets/images/logo/gas-logo-small.png"
                class="brand-logo"
              />
            </router-link>
          </li>
          <li class="nav-item hidden-md-up float-xs-right">
            <a
              data-toggle="collapse"
              data-target="#navbar-mobile"
              class="nav-link open-navbar-container"
            >
              <i class="icon-ellipsis pe-2x icon-icon-rotate-right-right"></i>
            </a>
          </li>
        </ul>
      </div>
      <div class="navbar-container content container-fluid">
        <div id="navbar-mobile" class="collapse navbar-toggleable-sm">
          <ul class="nav navbar-nav">
            <li class="nav-item hidden-sm-down">
              <a class="nav-link nav-menu-main menu-toggle hidden-xs">
                <i class="icon-menu5"></i>
              </a>
            </li>
          </ul>
          <ul class="nav navbar-nav float-xs-right">
            <NotificationsDropdown />
            <li class="dropdown dropdown-user nav-item">
              <a
                href="#"
                data-toggle="dropdown"
                class="dropdown-toggle nav-link dropdown-user-link"
              >
                <span class="avatar avatar-online">
                  <img src="/static/app-assets/images/portrait/small/avatar-s-1.png" alt="avatar" />
                  <i></i>
                </span>
                <span class="user-name">
                  <i v-if="isProfileLoading" class="icon-ei-spinner-3 spin"></i>
                  <template v-else>{{username}} <span v-if="isDriver"> / &quot;{{ companyName }}&quot;</span></template>
                </span>
              </a>
              <div class="dropdown-menu dropdown-menu-right">
                <router-link to="/profile" class="dropdown-item"  v-if="!isDriver">
                  <i class="icon-head"></i>Профиль
                </router-link>
                <div class="dropdown-divider"  v-if="!isDriver"></div>
                <a @click="logout" class="dropdown-item">
                  <i class="icon-power3"></i>Выход
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import NotificationsDropdown from "@/components/NotificationsDropdown.vue";
import { mapGetters } from "vuex";
import { AUTH_LOGOUT } from "@/store/actions/auth";
import { USER_REQUEST } from "@/store/actions/user";
import { CARDS_CARD_USER_REQUEST } from  "@/store/actions/cards";

export default {
  name: "TopMenu",
  components: {
    NotificationsDropdown,
  },
  computed: {
    ...mapGetters(["isProfileLoading", "getProfile", "profileOnceLoaded", "isDriver", "getCardUser"]),
    username() {
      return this.getProfile.name || "";
    },
    companyName() {
      return this.getProfile.type == -1 ? this.getCardUser.client_name : '';
    }
  },
  created() {
    if (!this.profileOnceLoaded) {
      this.$store.dispatch(USER_REQUEST);
      this.$store.dispatch(CARDS_CARD_USER_REQUEST);
    }
  },
  methods: {
    logout: function () {
      this.$store.dispatch(AUTH_LOGOUT).then(() => {
        this.$router.push("/login");
      });
    },
  },
};
</script>